import MainWrapper from "@components/pages/common/MainWrapper";
import { JSON_SCHEMAS } from "@components/utils/constants";
import styledParser from "@libs/parser/styled-parser";
import JsonLdSchema from "@libs/schema/JsonLdSchema";
import { IContactUsResponse } from "../../../../types/modelResponses";
import ContactForm from "./ContactPage/ContactForm";

interface IContactUsPageProps {
  contactUs: IContactUsResponse;
}

const ContactUs = ({ contactUs }: IContactUsPageProps): JSX.Element => {
  const data = contactUs.data.attributes;

  return (
    <>
      <JsonLdSchema
        data={{ breadcrumbObjects: undefined }}
        type={JSON_SCHEMAS.LOCAL_BUSINESS}
      />
      <MainWrapper>
        <div className="z-1 relative mx-auto flex flex-col items-center rounded-3xl px-5 pt-[1.875rem] pb-[3.125rem] desktop:my-[6.5rem] desktop:w-[862px] desktop:items-start desktop:border-2 desktop:border-blue-5 desktop:bg-white desktop:px-[6.875rem] desktop:py-[3.375rem]">
          <div className="absolute -left-[50%] -bottom-[15rem] z-[-1] hidden h-[56.25rem] w-[100rem] -rotate-[3.5deg] bg-cover bg-no-repeat desktop:block" />

          <h1 className="text-h6 font-medium leading-[115%] desktop:pb-[1rem] desktop:leading-[120%]">
            {data.Title}
          </h1>
          {data.Subheading && (
            <div className="mb-6 flex pt-3 text-p13 text-midgray desktop:p-0 desktop:text-left desktop:text-p">
              {styledParser(data.Subheading)}
            </div>
          )}
          <ContactForm />
        </div>
      </MainWrapper>
    </>
  );
};

export default ContactUs;
